import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl, PatternValidator } from '@angular/forms';

@Directive({
    selector: '[formControlName][pattern][appPatternField]',
})
export class PatternFieldDirective {

    constructor(
        public ngControl: NgControl,
        public pattern: PatternValidator,
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {

    }

    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
        this.onInputChange(event);
    }

    @HostListener('keydown.backspace', ['$event'])
    keydownBackspace(event) {
        this.onInputChange(event.target.value);
    }

    onInputChange(value) {
        this.clearPatternElement();
        try {
            if (!(this.pattern.pattern as RegExp).test(value)) {
                this.elementRef.nativeElement.insertAdjacentHTML(
                    'afterend',
                    `
                    <span class="pattern pattern--invalid">
                      Formato incorrecto
                    </span>
                    `
                );
            }
        } catch (e) {
            console.error(e);
        }
    }

    clearPatternElement() {
        try {
            const patternElement = this.elementRef.nativeElement.parentElement.querySelectorAll('.pattern');
            for (const children of patternElement) {
                this.renderer.removeChild(this.elementRef.nativeElement, children);
            }
        } catch (e) {
            console.error(e);
        }
    }

}
